/**
 * QuoteCall form
 */
angular.module('elogbooksDirectives').directive('surveys', ['$http', 'apiClient', function ($http, apiClient) {
    return {
        restrict: 'A',
        require: ['ngModel'],
        scope: {
            ngModel: '=',
            editable: '='
        },
        templateUrl: '/modules/directives/survey/list/list.html'
    };
}]);
